export const STORE_KEY = '$notifications'

export const LOAD_NOTIFICATIONS = 'LOAD_NOTIFICATIONS'
export const LOAD_MORE_NOTIFICATIONS = 'LOAD_MORE_NOTIFICATIONS'
export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ'
export const POLL_NOTIFICATIONS = 'POLL_NOTIFICATIONS'

export const ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS'
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const START_POLL = 'START_POLL'
export const STOP_POLL = 'STOP_POLL'
export const UPDATE_LAST_POLL_DATE = 'UPDATE_LAST_POLL_DATE'
export const UPDATE_CURRENT_PAGE = 'UPDATE_CURRENT_PAGE'
export const UPDATE_NEXT_PAGE = 'UPDATE_NEXT_PAGE'

export const RESET_STORE = 'RESET_STORE'
export const GET_DISPLAYED_NOTIFICATION = 'GET_DISPLAYED_NOTIFICATION'
export const GET_NOTIFICATION_DURATION = 'GET_NOTIFICATION_DURATION'
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'
export const GET_UNREAD_NOTIFICATIONS = 'GET_UNREAD_NOTIFICATIONS'
export const HAS_UNREAD_NOTIFICATIONS = 'HAS_UNREAD_NOTIFICATIONS'
export const GET_NEXT_PAGE = 'GET_NEXT_PAGE'
